import { posthog } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { $settings } from '@velasca/utils/globals'

if ($settings.posthog_enabled && $settings.posthog_apikey) {
  posthog.init($settings.posthog_apikey, {
    api_host: 'https://app.posthog.com',
    // apparently there is currently a bug in posthog-js. See here: https://github.com/PostHog/posthog-js/issues/844. This is a workaround.
    persistence: 'localStorage+cookie',
    autocapture: false, // also see AutoCapture config https://posthog.com/docs/libraries/js#autocaptureconfig
    capture_pageleave: false,
    capture_pageview: false,
    capture_performance: false,
    disable_session_recording: true,
    // opt_out_capturing_by_default: true,
  })
}

/**
 * IMPORTANT NOTICE: This HOC is currently completely unused in the codebase.
 * We leave this here in case we need to use it in the future, for new Feature Flags or Experiments.
 *
 * @public - this tag is important so Knip don't report this component as unused. Reference: https://knip.dev/reference/jsdoc-tsdoc-tags#public
 */
export const withPostHog = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <PostHogProvider client={posthog}>
        <WrappedComponent {...props} />
      </PostHogProvider>
    )
  }
}
